// extracted by mini-css-extract-plugin
module.exports = {"border":"Image_border__Fx5Jv","none":"Image_none___9lOn"};